import { useQuery } from '@tanstack/react-query';
import { fetchingStudentsForTeachers } from '../api/teachers';

const useStudentsForOneTeacher = (userId, typeOfUser) => {
  return useQuery({
    queryKey: ['fetchingStudentsForOneTeacher', userId, typeOfUser],
    queryFn: async () => {
      if (typeOfUser !== 'TEACHER') return [];

      const fetchedData = await fetchingStudentsForTeachers(userId);
      return (
        fetchedData?.studentsList.map((teacher) => ({
          id: teacher.uid,
          name: teacher.info.name || teacher.info.fullname || '',
          email: teacher.info.email,
          parentName: teacher.info.parentName,
          schoolName: teacher.info.schoolName || '',
          gender: teacher.info.gender || '',
          selfDescribeGender: teacher.info.selfDescribeGender || '',
          photoURL: teacher.info?.photoURL || null,
        })) || []
      );
    },
    // staleTime: 0, // Always consider data stale for real-time updates
    // cacheTime: 300000, // 5 min cache
    // refetchInterval: 3000, // Refetch every 3 seconds for faster updates
    // refetchOnWindowFocus: true, // Refetch when window regains focus
    // refetchOnMount: true, // Refetch when component mounts
    staleTime: 10 * 60 * 1000, // 10 minutes - data is considered fresh for 10 min
    gcTime: 30 * 60 * 1000, // 30 minutes cache (formerly cacheTime)
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnMount: false, // Don't refetch when component mounts if data is fresh
    refetchOnReconnect: true, // Refetch when reconnecting to network
    onError: (error) => {
      console.error('Error fetching students for one teacher:', error);
    },
  });
};

export default useStudentsForOneTeacher;
